import clsx from 'clsx';
import React from 'react';

import TopicPill from '../Topic/TopicFollowAndTagModal/TopicPill';
import type { SearchPageProps } from './index';

type SearchHeaderProps = Pick<SearchPageProps, 'title' | 'topRelatedEntities'>;

const SearchHeader = ({ title, topRelatedEntities }: SearchHeaderProps) => {
  return (
    <div className="tw-mt-24 tw-mb-12">
      <div className="tw-mt-8 tw-mb-24 tw-text-grayscale-50 tw-font-bold tw-text-headline-sm tw-font-serif">
        Search results for: &ldquo;{title}&rdquo;
      </div>
      <div className="tw-border-solid tw-border-0 tw-border-y tw-border-neutral-300 tw-py-8 tw-text-overline tw-uppercase">
        Related Topics
      </div>
      <div className="tw-mt-12 tw-flex tw-items-center tw-gap-4">
        {topRelatedEntities.map(({ matchingEntity, name }) => (
          <TopicPill
            className={clsx({
              '!tw-bg-primary-red hover:!tw-bg-red-400 !tw-text-white': matchingEntity,
            })}
            key={name}
            topic={name}
          />
        ))}
      </div>
    </div>
  );
};

export default SearchHeader;
